<template>
  <div class="note_wrap">
    <div class="menu-toggle" :class="{ 'menu-open': !menuFlag }" @click="toggleMenu"></div>
    <div class="note_left" v-if="menuFlag">
      <div class="top_title" @click="allNote($event)">
      	<img src="../../../../../../static/images/study/icon/zhangjie_all.png"/>
      	<h3>全部章节</h3>
      </div>
      <div class="catalog_tree">
      	<el-tree
          :data="catalogData"
          :props="defaultProps"
          node-key="id"
          :highlight-current="true"
          @node-click="handleNodeClick"
          :indent="16"
        >
         <span class="span-ellipsis" slot-scope="{ node }">
            <span :title="node.label">{{ node.label }}</span>
          </span>
        </el-tree>
      </div>
    </div>
    <div class="note_right">
      <el-tabs v-model="activeName" @tab-click="handleClick" v-if="noteFlag">
		    <el-tab-pane label="我的笔记" name="first">
		    	<mynote v-if="btnFlag && !editorNote" ref="mynote" @backNote="backNote" @editorNoteOpen="editorNoteOpen" v-loading="loading"></mynote>
		    </el-tab-pane>
		    <el-tab-pane label="同学笔记" name="second">
		    	<classnote v-if="btnFlag && !editorNote" ref="classnote" @backNote="backNote" @editorNoteOpen="editorNoteOpen" v-loading="loading"></classnote>
		    </el-tab-pane>
		  </el-tabs>
		  <a class="btn" @click="addNote()" v-if="btnFlag && !editorNote" >添加笔记</a>
		  <a class="btn_back" @click="backNote()" v-if="!btnFlag || editorNote">返回</a>
		  <span class="note_text" v-if="!noteFlag">{{noteText}}</span>
		  <el-divider v-if="!noteFlag"></el-divider>
		  <!--添加笔记-->
		  <addnote v-if="!btnFlag && !editorNote" @backNote="backNote" :catalog-id="catalogId"></addnote>
		  <!--编辑笔记-->
			<editornote v-if="btnFlag && editorNote" @backNote="backNote"></editornote>
    </div>
  </div>
</template>

<script>
	import mynote from './myNote.vue';
	import classnote from './classNote.vue';
	import addnote from './addNote.vue';
	import editornote from './editorNote.vue';
	import * as api from "../../../../../api/noteApi";
  export default {
    name: "note",
    components:{
    	mynote,
    	classnote,
    	addnote,
    	editornote
		},
		props:{
			isTurn:{ //是否是跳转过来的
				type: Boolean,
				default: true
			},
			CataId:''//目录ID
		},
    data(){
      return{
        menuFlag: true,
        loading: false,
        activeName:'first',
        btnFlag:true,
        catalogData:[], //章节目录
        defaultProps:{
        	children: "children",
        	label: "catalogName"
        },
        catalogItem:{},
        catalogId:'',
        editorNote:false,
        userType:sessionStorage.getItem('userType'),
        noteFlag:true,
        noteText:'添加笔记'
      }
    },
    created(){
			let id = ''
			if(!this.isTurn){
				id = this.CataId
			}else{
				id=this.$route.query.id
			}
			this.getCatalog(id);
    },
    mounted(){
      $(".container-header").hide();
      $(".top_title").addClass('active');
    },
    methods: {
    	// 获取章节目录
    	getCatalog(id){
    		api.getCatalogList(id).then(res=>{
    			if(res.code == 0){
    				this.catalogData = res.data;
    				this.$nextTick(()=>{
  						this.activeName = 'first';
							this.$refs.mynote.getMyNote({});
    				});
    			}
    		}).catch(error=>{
    			console.log(error)
    		});
    	},
    	// 全部章节
    	allNote(e){
    		let el = e.currentTarget;
    		el.className += " active";
    		this.btnFlag = true;
      	this.editorNote = false;
      	this.noteFlag = true;

        let id = ''
        if(!this.isTurn){
          id = this.CataId
        }else{
          id=this.$route.query.id
        }
      	this.getCatalog(id);
    		this.catalogId = '';
    		this.catalogItem = {
    			id:'',
      		catalogName:''
    		};
    	},
      toggleMenu() {
        this.menuFlag = !this.menuFlag;
      },
      handleClick(tab, event) {
        if(this.activeName == 'second'){
        	this.$refs.classnote.getClassNote(this.catalogItem);
        }else{
        	this.$refs.mynote.getMyNote(this.catalogItem);
        }
      },
      // 添加笔记
      addNote(){
      	if(!this.catalogId){
      		this.$tipsDialog(
						"提示",
						"默认选中全部章节，如需切换其他章节，请重新选择。确定继续添加笔记吗？",
						"",
						"",
						"rgb(255, 178, 60)"
					).then(() => {
	        	this.btnFlag = false;
      			this.editorNote = false;
      			this.noteFlag = false;
      			this.noteText = '添加笔记';
	        }).catch(()=>{})
      	}else{
      		this.btnFlag = false;
      		this.editorNote = false;
      		this.noteFlag = false;
      		this.noteText = '添加笔记';
      	}
      },
      // 返回
      backNote(){
      	this.btnFlag = true;
      	this.editorNote = false;
      	this.noteFlag = true;
      	if(this.activeName == 'second'){
      		this.$nextTick(()=>{
	      		this.$refs.classnote.getClassNote(this.catalogItem);
	      	})
      	}else{
      		this.$nextTick(()=>{
	      		this.$refs.mynote.getMyNote(this.catalogItem);
	      	})
      	}
      },
      // 点击章节目录
      handleNodeClick(data){
      	console.log(data);
      	this.btnFlag = true;
      	this.editorNote = false;
      	this.noteFlag = true;
      	this.loading = true;
      	this.$nextTick(()=>{
					this.$refs.mynote.getMyNote(data);
					// this.$refs.mynote.getNum(0);
					this.activeName = 'first'
      		this.loading = false;
      	})
      	this.catalogId = data.id;
      	this.catalogItem = data;
      	$(".top_title").removeClass('active');
      },
      // 编辑笔记
      editorNoteOpen(){
      	this.editorNote = true;
      	this.btnFlag = true;
      	this.noteFlag = false;
      	this.noteText = '编辑笔记'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .note_wrap{
    width: 100%;
    height: 100%;
    display: flex;
    background: #F4F4F4;
    .note_left{
      width:264px;
      height: calc(100% - 32px);
      background:rgba(232,242,255,1);
      border-radius:0px 4px 4px 0px;
      margin-top: 16px;
      overflow:auto;
      ul{
        margin-top: 28px;
        li{
          width:200px;
          height:40px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          img{
            width: 16px;
          }
          p{
            font-size:14px;
            font-weight:400;
            color:rgba(102,102,102,1);
            margin-left: 6px;
          }
        }
        .active{
          background: #fff;
        }
      }
      .top_title {
      	display: flex;
      	justify-content: flex-start;
      	align-items: center;
      	margin-top: 22px;
      	height: 36px;
      	padding: 0 34px;
      	margin-bottom: 15px;
      	cursor: pointer;
      	&:hover {
      		background: #F5F7FA;
      	}
      	&.active {
      		background: #fff;
      		h3 {
      			color: #5397F7;
      		}
      	}
      	img {
      		display: inline-block;
      		width: 17px;
      		height: 17px;
      		margin-right: 6px;
      	}
      	h3 {
      		font-size: 16px;
      		color: #666666;
      	}
      }
      .catalog_tree {
      	.el-tree {
      		background: none;
      		color: #666666;
      	}
      	/deep/ .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
      		background-color: #fff;
      		color: #5397F7;
      	}
      	/deep/ .el-tree-node__content {
      		font-size: 14px;
      		height: 36px;
      		.span-ellipsis {
      			overflow: hidden;
      			text-overflow: ellipsis;
      			white-space: nowrap;
      			padding-right: 20px;
      		}
      	}
      }
    }
    .note_right{
    	position: relative;
      flex: 1;
      margin: 16px;
      height: calc(100% - 53px);
      background: #fff;
      padding: 10px 24px;
      /deep/ .el-tabs__item {
      	color: #666666;
      	font-size: 16px;
      	&:hover {
      		color: #333333;
      	}
      }
      /deep/ .el-tabs__item.is-active {
      	color: #333333;
      	font-weight: 600;
      }
      /deep/ .el-tabs__active-bar {
      	background-color: #333333;
      	height: 1px;
      }
      /deep/ .el-tabs__nav-wrap::after {
      	height: 1px;
      }
      .btn {
      	position: absolute;
      	top: 10px;
      	right: 24px;
      	width:80px;
				height:30px;
				line-height: 30px;
				text-align: center;
				background:rgba(255,255,255,1);
				border:1px solid rgba(83,151,247,1);
				opacity:1;
				border-radius:4px;
				cursor: pointer;
				color: #5397F7;
				font-size: 14px;
				&:hover {
					background:#ecf5ff;
				}
      }
      .btn_back {
      	position: absolute;
      	top: 10px;
      	right: 24px;
      	width:72px;
				height:30px;
				line-height: 30px;
				text-align: center;
				background:rgba(255,255,255,1);
				border:1px solid rgba(83,151,247,1);
				opacity:1;
				border-radius:4px;
				cursor: pointer;
				color: #5397F7;
				&:hover {
					background:#ecf5ff;
				}
      }
      .note_text {
      	position: absolute;
      	top: 10px;
      	left: 24px;
      	width:72px;
				height:30px;
				line-height: 30px;
				font-size: 16px;
      }
      .el-divider--horizontal {
      	margin: 40px 0;
      	margin-bottom: 20px;
      }
    }
    .menu-toggle {
      position: absolute;
      top: 50%;
      left: 264px;
      width: 16px;
      height: 64px;
      margin-top: -32px;
      cursor: pointer;
      background: url("../../img/close.png");
      background-size: 100% 100%;
    }
    .menu-open {
      left: 0;
      background: url("../../img/close_right.png");
      background-size: 100% 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/note/note.vue